module.exports = __webpack_public_path__ + "media/images/athletes/2801-5ca88692109178bcdfa0779b0c103be7.png";